import React from "react";
import { avatarAtomFamily } from "../jotai/atoms";
import { useAtom } from "jotai";
import { avatars } from "../utils/data";

export default function Avatar({ recordId, loading }: { recordId: string; loading?: boolean }) {
  const [avatarId] = useAtom(avatarAtomFamily(recordId));

  if (!avatarId || !avatars.get(avatarId)) {
    return (
      <div
        className={`relative rounded-full w-full h-full bg-[url(/assets/images/user_white.png)] bg-cover ${
          loading ? "opacity-20" : ""
        }`}
      >
        {loading && (
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 loading loading-spinner loading-xl text-neutral"></span>
        )}
      </div>
    );
  }

  return (
    <div
      className={`relative rounded-full w-full h-full bg-cover ${loading ? "opacity-20" : ""}`}
      style={{ backgroundImage: `url(${avatars.get(avatarId)})` }}
    >
      {loading && (
        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 loading loading-spinner loading-xl text-neutral"></span>
      )}
    </div>
  );
}
